import React from 'react';
import { LoadingImage, eBrandImageSizes } from '../BrandImages';

export interface IItemLoadingProps {
  isLoading: boolean;
}

export const ItemLoading: React.FC<IItemLoadingProps> = ({ isLoading }) => {
  return (
    <>
      {isLoading && (
        <div className={'absolute top-0 left-0 bottom-0 right-0 z-10 grid items-center justify-center backdrop-blur'}>
          <LoadingImage imageSize={eBrandImageSizes.Normal} />
        </div>
      )}
    </>
  );
};
